import React from 'react'
import SubHeader from '../general/SubHeader';
import WhatsappImg from '../assets/whatsapp-img.webp';
import { Link } from 'react-router-dom';


const Contact = () => {
    return (
        <>
            <SubHeader message="Contact Us" />
            {/* map section */}
            <section className='container my-5'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3602.2612160194203!2d81.85966507539051!3d25.462951677540854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDI3JzQ2LjYiTiA4McKwNTEnNDQuMSJF!5e0!3m2!1sen!2sin!4v1734942047327!5m2!1sen!2sin"
                    className='w-100' height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </section>
            {/* map section ends */}


            {/* form section */}
            <section className='my-5'>
                <div className='container'>

                    <div className='row'>

                        <div className='col-lg-7 col-12 my-2'>
                            <p className='sec-heading5'>Get In Touch</p>

                            <form class="row g-3">
                                <div class="col-12">
                                    <textarea type="text" class="form-text" id="inputMessage4" placeholder='Message' style={{ height: '12em' }}></textarea>
                                </div>
                                <div class="col-12">
                                    <input type="text" class="form-text" id="inputName4" placeholder='Name' />
                                </div>
                                <div class="col-md-6">
                                    <input type="email" class="form-text" id="inputEmail4" placeholder='Email' />
                                </div>
                                <div class="col-md-6">
                                    <input type="tel" class="form-text" id="inputEmail4" placeholder='Phone' />
                                </div>
                                <div class="col-12">
                                    <button type="submit" class="donate-btn">Send</button>
                                </div>
                            </form>

                        </div>

                        <div className='col-lg-4 col-12 my-2 text-muted ms-lg-auto'>

                            <div className='d-flex my-3'>
                            <i class="fa-regular fa-building contact-icon me-3"></i>
                            <p><span className='fw-bold text-dark'>Location</span><br />Office Address: H No. 247, Kasturipur Kasturi, Holagarh Soraon, Allahabad, Uttar
                            Pradesh, 212503<br /><br />
                            Registered Address: 30/2 Dibya Niwas, Near Allahabad University, Old Katra, Prayagraj, Uttar Pradesh, 211002</p>
                            </div>
                            {/* flex ends */}

                            <div className='d-flex my-3'>
                            <i class="fa-solid fa-mobile-screen contact-icon me-3"></i>
                            <p><span className='fw-bold text-dark'>Contact</span><br />9599332740<br />
                            8178042539</p>
                            </div>
                            {/* flex ends */}


                            <div className='d-flex my-3'>
                            <i class="fa-regular fa-envelope contact-icon me-3"></i>
                            <p><span className='fw-bold text-dark'>Email</span><br />info@anvifoundation.com</p>
                            </div>
                            {/* flex ends */}

                        </div>

                    </div>
                    {/* row ends */}

                </div>
            </section>
            {/* form section ends */}


            <Link to='https://wa.me/9599332740?text=Hello%20I%20want%20know%20about%20Anvi%20Foundation.' target='_blank' >
            <img src={WhatsappImg} className='whatsapp-icon' alt='Whatsapp link' /></Link>

        </>
    )
}

export default Contact
